module.exports = __webpack_public_path__ + "static/logo-4810796502cf2ae85d263ee41f1ef69f.svg";